import { render, staticRenderFns } from "./ConsignadoPages.vue?vue&type=template&id=df1ab300&"
import script from "./ConsignadoPages.vue?vue&type=script&lang=js&"
export * from "./ConsignadoPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports